module.exports = __webpack_public_path__ + "static/media/visual-grammar-img-001.74c03c21.jpg";